import { useSyncExternalStore } from 'react';

/** One shared clock for every auto-updating timestamp on the page (ticks every 30 seconds). */
const TICK_MS = 30_000;
const listeners = new Set<() => void>();
let now = Date.now();
let timer: ReturnType<typeof setInterval> | undefined;

function tick() {
  now = Date.now();
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  if (timer === undefined) {
    now = Date.now();
    timer = setInterval(tick, TICK_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && timer !== undefined) {
      clearInterval(timer);
      timer = undefined;
    }
  };
}

const getSnapshot = () => now;

/** Current time (ms) that re-renders subscribers every 30 seconds. */
export const useNow = (): number => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
